import type { CustomerOverview } from '@weft/api-definition';
import type { NewBillingCycle } from '@weft/types';
import { extract } from '@weft/utils';
import { Multiselect } from 'apps/app/src/assets/components/design/Multiselect';
import { useState, useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { CloseButton } from '../../../components/design/buttons/CloseButton';
import { useCustomersOverviews } from '../../../hooks/requests/use-customers-overviews/use-customers-overviews';

export const CustomersDropdown = () => {
  const { setValue } = useFormContext<NewBillingCycle>();

  const { data } = useCustomersOverviews();
  const customers = data?.customers ?? [];

  const [selectedCustomers, setSelectedCustomers] = useState<CustomerOverview[]>([]);

  useEffect(() => {
    const customersIds = extract(selectedCustomers, 'id');
    setValue('customersIds', customersIds);
  }, [selectedCustomers]);

  const removeSelectedCustomer = (customerId?: string) => {
    const filteredValues = selectedCustomers?.filter((customer: CustomerOverview) => customer.id !== customerId);
    setSelectedCustomers(filteredValues);
  };

  return (
    <div>
      <Multiselect
        items={customers}
        selectedItems={selectedCustomers ?? []}
        getDisplayValue={(customer) => customer.name}
        getId={(customer) => customer.id}        
        onItemsChanged={setSelectedCustomers}
        placeholder='Type Customer Here'
        label='Customers'
        containerClassName='min-w-[317px]'
        inputClassName='rounded-none'
        optionClassName='py-2 pl-6 pr-4'
      />
      <div className="bg-input flex min-h-[94px] flex-wrap gap-2 p-4">
        {selectedCustomers?.map((customer: CustomerOverview) => {
          return (
            <div
              key={customer.id}
              className="bg-style flex h-8 w-fit items-center justify-between gap-2 rounded-full px-3 py-1.5 text-white"
            >
              <div className="text-sm">{customer.name}</div>
              <CloseButton
                iconColor="#FFF"
                iconClassName="h-2.5 w-2.5 cursor-pointer"
                onClick={() => removeSelectedCustomer(customer.id)}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};